import { PLACEMENT as e } from "../../values/Placement.js";
import t, { forwardRef as n, isValidElement as r, useEffect as i, useState as a } from "react";
import { jsx as o, jsxs as s } from "react/jsx-runtime";
//#region src/components/popover/Popover.tsx
var c = {
	TOP: e.TOP,
	RIGHT: e.RIGHT,
	BOTTOM: e.BOTTOM,
	LEFT: e.LEFT
}, l = ({ className: e = "", children: t }) => /* @__PURE__ */ o("div", {
	className: `popover-header popover-title ${e}`,
	children: t
}), u = ({ className: e = "", children: t }) => /* @__PURE__ */ o("div", {
	className: `popover-content popover-body ${e}`,
	children: t
}), d = (e) => r(e) && (e.type === l || e.type === u), f = n((e, n) => {
	let { placement: r = "bottom", arrowProps: c, showArrow: f = !0, title: p, titleClassName: m = "", contentClassName: h = "", children: g, className: _ = "", style: v, ...y } = e, b = !!p, x = t.Children.toArray(g).some(d), [S, C] = a(!1);
	i(() => C(!0), []);
	let w = { popover: "manual" }, T = {
		...v,
		...f ? {} : { "--overlay-arrow-size": "0px" }
	};
	return /* @__PURE__ */ s("div", {
		"data-overlay-arrow-placement": r,
		...y,
		...w,
		role: "tooltip",
		ref: n,
		className: `popover fade ${S ? "show" : ""} ${_}`,
		style: T,
		children: [
			f && /* @__PURE__ */ o("div", {
				className: "arrow",
				...c
			}),
			b && /* @__PURE__ */ o(l, {
				className: m,
				children: p
			}),
			x ? g : /* @__PURE__ */ o(u, {
				className: h,
				children: g
			})
		]
	});
});
f.Title = l, f.Content = u, Object.assign(f, c);
//#endregion
export { c as PLACEMENT_MAP, f as default };

//# sourceMappingURL=Popover.js.map